<template>
  <client-only>
    <noscript>
      <iframe
        v-if="_gtmKey"
        :src="`https://www.googletagmanager.com/ns.html?id=${_gtmKey}`"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
  </client-only>
</template>
<script setup lang="ts">
const {
  public: { gtmKey: _gtmKey },
} = useRuntimeConfig();
</script>
